export default "__VITE_ASSET__e51acf5f__"